export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const MARK_NOTIFICATION_READ_SUCCESS = 'MARK_NOTIFICATION_READ_SUCCESS';
export const MARK_NOTIFICATION_READ_ERROR = 'MARK_NOTIFICATION_READ_ERROR';

export interface MarkNotificationRead {
  type: typeof MARK_NOTIFICATION_READ;
  payload: { id: number };
}

export interface MarkNotificationReadSuccess {
  type: typeof MARK_NOTIFICATION_READ_SUCCESS;
  payload: { id: number };
}

export interface MarkNotificationReadError {
  type: typeof MARK_NOTIFICATION_READ_ERROR;
  payload: string | boolean;
}

export interface State {
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = MarkNotificationRead | MarkNotificationReadSuccess | MarkNotificationReadError;
